import { Typography, Chip, Stack, Tooltip, Link, IconButton } from "@mui/material";
import MyButton from "@components/atoms/MyButton/MyButton";
import { Link as ReactRouterLink } from "react-router-dom";
import { PencilSquare, Eye, Download } from "react-bootstrap-icons";
import { IClient, IProduct, IReceiptDetail, IRemisionDetail, ITableHeader, ITableRow, RemisionState } from "src/types/global";
import { transactionService } from "@services/TransactionService";
export const toSubarrays = (array: any[], tamanoSubarray: number) => {
  var subarrays = [];
  for (var i = 0; i < array.length; i += tamanoSubarray) {
    var subarray = array.slice(i, i + tamanoSubarray);
    subarrays.push(subarray);
  }
  return subarrays;
};
export const formatDate = (date: string) => date.split("T")[0].split("-").reverse().join("/");
export const getCurrency = (value: number | string) => value.toLocaleString("es-CO", {
  style: "currency",
  currency: "COP"
});
export const getCurrentDate = () => {
  const today = new Date();
  return `${String(today.getDate()).padStart(2, "0")}/${String(today.getMonth() + 1).padStart(2, "0")}/${today.getFullYear()}`;
};
export const getCleanCurrency = (value: number | string) => value.toLocaleString("es-CO", {
  style: "currency",
  currency: "COP"
}).replaceAll("$", "").trim();
export const getNumberCurrency = (value: string) => {
  const numberValue = parseFloat(value.replaceAll(".", "").replaceAll(",", ".").replaceAll(/\s+/g, ""));
  return isNaN(numberValue) ? 0 : numberValue;
};
export const createHeader = (label: string, id: string): ITableHeader => ({
  label,
  id
});
export const createReceiptRow = (id: number, name: string, clientName: string, identification: string, creationTime: string, limitDate: string, total: number, status: boolean, type: number): ITableRow => ({
  name: <Typography color={type === 1 ? "primary" : "secondary"} fontWeight={700}>
      {name}
    </Typography>,
  clientName,
  identification: identification || "N/A",
  limitDate: formatDate(limitDate),
  creationTime: formatDate(creationTime),
  balance: getCurrency(total),
  status: status ? <Chip color="success" sx={{
    fontWeight: 600
  }} label="Activo" /> : <Chip color="secondary" sx={{
    fontWeight: 600
  }} label="Cerrado" />,
  actions: <Stack direction={"row"} justifyContent={"center"} spacing={1}>
      <Tooltip title="Editar">
        <Link component={ReactRouterLink} to={`/productos/editar/${id}`}>
          <MyButton>
            <PencilSquare size={22} />
          </MyButton>
        </Link>
      </Tooltip>
      <Tooltip title="Ver">
        <Link component={ReactRouterLink} to={`/recibos/${id}`} state={({
        id: String(id),
        clientName,
        total
      } as IReceiptDetail)}>
          <MyButton>
            <Eye size={22} />
          </MyButton>
        </Link>
      </Tooltip>
    </Stack>
});
export const REMISION_STATE_CHIP: Record<RemisionState, {
  color: "default" | "primary" | "secondary" | "info" | "success" | "warning" | "error";
  label: string;
}> = {
  Creado: {
    color: "success",
    label: "Creado"
  },
  Pagado: {
    color: "info",
    label: "Pagado"
  },
  Aprobado: {
    color: "warning",
    label: "Aprobado"
  },
  Despachado: {
    color: "secondary",
    label: "Despachado"
  },
  Cerrado: {
    color: "default",
    label: "Cerrado"
  }
};
export const createRemisionRow = (id: number, name: string, clientName: string, creationTime: string, limitDate: string, total: number, state: RemisionState, type: number): ITableRow => {
  const chipProps = REMISION_STATE_CHIP[state] ?? {
    color: ("default" as const),
    label: state
  };
  return {
    name: <Typography color={type === 1 ? "primary" : "secondary"} fontWeight={700}>
      {name}
    </Typography>,
    clientName,
    limitDate: formatDate(limitDate),
    creationTime: formatDate(creationTime),
    balance: getCurrency(total),
    status: <Chip color={chipProps.color} sx={{
      fontWeight: 600
    }} label={chipProps.label} />,
    actions: <Stack direction={"row"} justifyContent={"center"} spacing={1}>
      <Tooltip title="Ver">
        <Link component={ReactRouterLink} to={`/remisiones/${id}`} state={({
          id: String(id),
          clientName,
          total
        } as IRemisionDetail)}>
          <MyButton>
            <Eye size={22} />
          </MyButton>
        </Link>
      </Tooltip>
    </Stack>
  };
};
export const createClientRow = (id: number, fullName: string, identification: string, phone: string, email: string, creationTime: string): ITableRow => ({
  id,
  fullName,
  identification: identification || "N/A",
  phone,
  email: email || "N/A",
  creationTime: formatDate(creationTime),
  actions: <Stack direction={"row"} justifyContent={"center"} spacing={1}>
      <Tooltip title="Editar">
        <Link component={ReactRouterLink} to={`/clientes/editar/${id}`} state={({
        id,
        fullName,
        identification,
        phone,
        email,
        creationTime: formatDate(creationTime)
      } as IClient)}>
          <MyButton>
            <PencilSquare size={22} />
          </MyButton>
        </Link>
      </Tooltip>
      <Tooltip title="Ver">
        <Link component={ReactRouterLink} to={`/clientes/${id}`} state={({
        id,
        fullName,
        identification,
        phone,
        email,
        creationTime: formatDate(creationTime)
      } as IClient)}>
          <MyButton>
            <Eye size={22} />
          </MyButton>
        </Link>
      </Tooltip>
    </Stack>
});
export const createProductRow = (id: number, name: string, reference: string, price: string, status: number): ITableRow => ({
  id,
  name,
  reference,
  price,
  priceRender: getCurrency(price),
  status,
  statusRender: status === 0 ? <Chip color="success" sx={{
    fontWeight: 600
  }} label="Activo" /> : <Chip color="secondary" sx={{
    fontWeight: 600
  }} label="Inactivo" />,
  actions: <Stack direction={"row"} justifyContent={"center"} spacing={1}>
      <Tooltip title="Editar">
        <Link component={ReactRouterLink} to={`/productos/editar/${id}`} state={({
        id,
        reference,
        description: name,
        price,
        status
      } as IProduct)}>
          <MyButton>
            <PencilSquare size={22} />
          </MyButton>
        </Link>
      </Tooltip>
      <Tooltip title="Ver">
        <Link component={ReactRouterLink} to={`/productos/${id}`} state={({
        id,
        reference,
        description: name,
        price,
        status
      } as IProduct)}>
          <MyButton>
            <Eye size={22} />
          </MyButton>
        </Link>
      </Tooltip>
    </Stack>
});
export const createTransactionRow = (amount: number, transactionType: number, receiptId: number, creationTime: string, successColor: string, errorColor: string, employeeName: string | null, applicant?: string, transactionId?: number, paymentMethod?: number, transferProofPath?: string | null, onDownloadError?: () => void): ITableRow => ({
  amount: <Typography fontWeight={600} color={amount >= 0 ? successColor : errorColor}>
      {getCurrency(amount)}
    </Typography>,
  transaction: <Typography paddingY={1} fontWeight={600}>
      {transactionType === 0 ? "Directo" : "Global"}
    </Typography>,
  paymentMethod: <Typography fontWeight={600}>
      {paymentMethod === 1 ? "Transferencia" : "Efectivo"}
    </Typography>,
  receipt: <Link component={ReactRouterLink} to={`/recibos/${receiptId}`} fontSize={"1rem"} fontWeight={600}>
      {receiptId}
    </Link>,
  creationTime: formatDate(creationTime),
  employeeName: employeeName || "N/A",
  applicant: applicant || "N/A",
  proof: transferProofPath && transactionId != null ? <Tooltip title="Descargar comprobante">
      <IconButton size="small" onClick={async () => {
      try {
        await transactionService.downloadTransferProof(transactionId);
      } catch {
        onDownloadError?.();
      }
    }}>
        <Download size={18} />
      </IconButton>
    </Tooltip> : <Typography color="text.secondary">—</Typography>
});